import { render, staticRenderFns } from "./base_index.vue?vue&type=template&id=ec66fe8a&scoped=true&"
import script from "./base_index.vue?vue&type=script&lang=js&"
export * from "./base_index.vue?vue&type=script&lang=js&"
import style0 from "./base_index.vue?vue&type=style&index=0&id=ec66fe8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec66fe8a",
  null
  
)

export default component.exports